import { testimonials } from "@/mocks/content";

export default function Testimonials() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
            <i className="ri-chat-smile-2-line"></i>
            观众留言
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            不同观众的追剧方式
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            有人追悬疑、有人看治愈、有人把经典当背景音。下面是一些观众的追剧习惯分享，
            也许能给你一些参考。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span
                className={`flex h-9 w-9 items-center justify-center rounded-full ${
                  index % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className="ri-double-quotes-l text-base"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-6 text-foreground-800">
                {item.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-600">{item.tag}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}